var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.571,
    height: 13.657,
    viewBox: "0 0 19.571 13.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-email",
    "data-name": "Icon material-email",
    d: "M20.614,6H4.957A1.955,1.955,0,0,0,3.01,7.957L3,17.7a1.963,1.963,0,0,0,1.957,1.957H20.614A1.963,1.963,0,0,0,22.571,17.7V7.957A1.963,1.963,0,0,0,20.614,6Zm0,3.914-7.829,4.893L4.957,9.914V7.957l7.829,4.893,7.829-4.893Z",
    transform: "translate(-3 -6)",
    fill: "#8faa44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.73faa69a6342b0b13a665532fa63163a.svg";
export { ForwardRef as ReactComponent };